import React from 'react';


export const Close = ({ className }) => (
    <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='18' height='2' transform='matrix(0.707107 -0.707107 -0.707107 -0.707107 6 19)' fill='#FF3200' />
        <rect width='18' height='2' transform='matrix(0.707107 0.707107 0.707107 -0.707107 5 6)' fill='#FF3200' />
    </svg>
);
